import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'notification-permission-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-permission-banner.html',
})
export class NotificationBannerComponent {
  @Output() close = new EventEmitter<void>();
  @Output() enable = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  onEnable(): void {
    this.enable.emit();
  }
}
